import React from "react";
import styles from "./PayAttention.module.scss";

const PayAttention: React.FC = () => {
  return (
    <section className={styles.payAttention}>
      <div className="container">
        <div className={styles.info}>
          <h2 className={styles.title}>Обратите внимание!</h2>
          <div className={styles.text}>
            <p>
              Информируем вас, что в свете возросшего числа мошеннических схем вся коммуникация о заказах и возврате, а также
              любые другие переписки с нашими клиентами осуществляются
              <span>&nbsp; исключичетльно через мессенджер WhatsApp. Другие каналы мы не используем.</span>
            </p>
            <p>
              Сотрудники компании не удаляют сообщения в чате и не отправляют их, применяя функцию однократного просмотра. Мы
              сохраняем все диалоги с заказчиками.
            </p>
            <p>
              Чтобы убедиться в том, что вы общаетесь именно с нами, сверяйте контакты с данными на сайте Тканополис.
              Пожалуйста, проявляйте осторожность!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PayAttention;
